import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "eva-body"
};
var _hoisted_2 = {
  class: "student-eva__header"
};
var _hoisted_3 = {
  class: "student__info"
};
var _hoisted_4 = {
  class: "name"
};
var _hoisted_5 = {
  class: "group-eva__content"
};
var _hoisted_6 = {
  class: "group-eva__footer"
};
var _hoisted_7 = {
  class: "tip-box"
};
import { toRefs, watch, ref } from 'vue';
import { useModel } from '@/hooks/useModel';
import Avatar from './Avatar.vue';
import Evaluate from './Evaluate.vue';
import TargetTree from './TargetTree.vue';
import useEvaluate from '../hooks/useEvaluate';
export default {
  __name: 'StudentEvaDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    stuItem: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    classInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['update:visible', 'refresh'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var _useEvaluate = useEvaluate(emit),
      treeData = _useEvaluate.treeData,
      targetItem = _useEvaluate.targetItem,
      commentData = _useEvaluate.commentData,
      count = _useEvaluate.count,
      evaluateRef = _useEvaluate.evaluateRef,
      submitLoading = _useEvaluate.submitLoading,
      initData = _useEvaluate.initData,
      closeEvent = _useEvaluate.closeEvent,
      checkTargetEvent = _useEvaluate.checkTargetEvent,
      studentSubmitEvent = _useEvaluate.studentSubmitEvent;
    var visible = useModel({
      props: props,
      emit: emit,
      key: 'visible'
    });
    var _toRefs = toRefs(props),
      stuItem = _toRefs.stuItem;
    var localVisible = ref(props.visible);
    watch(function () {
      return props.visible;
    }, function (value) {
      localVisible.value = value;
    });
    watch(function () {
      return localVisible.value;
    }, function (value) {
      emit('update:visible', value);
    });
    watch(function () {
      return props.visible;
    }, function (value) {
      if (value) {
        initData(stuItem.value);
      }
    }, {
      immediate: true
    });

    /**
     * 提交事件
     */
    var submitEvent = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var selectList, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              selectList = [stuItem.value];
              _context.n = 1;
              return studentSubmitEvent(selectList, props.classInfo);
            case 1:
              _t = _context.v;
              if (_t) {
                _context.n = 2;
                break;
              }
              _t = false;
            case 2:
              res = _t;
              emit('update:visible', res ? false : true);
              if (res) emit('refresh');
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function submitEvent() {
        return _ref2.apply(this, arguments);
      };
    }();
    var cancelEvent = function cancelEvent() {
      closeEvent();
      emit('update:visible', false);
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_drawer = _resolveComponent("t-drawer");
      return _openBlock(), _createBlock(_component_t_drawer, {
        visible: localVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return localVisible.value = $event;
        }),
        placement: "right",
        zIndex: 5500,
        size: "760px",
        destroyOnClose: "",
        header: null,
        footer: null,
        onClosed: _unref(closeEvent)
      }, {
        default: _withCtx(function () {
          var _unref2, _unref3;
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("span", null, "评价验收", -1)), _createElementVNode("div", _hoisted_3, [_createVNode(Avatar, {
            avatarUrl: (_unref2 = _unref(stuItem)) === null || _unref2 === void 0 ? void 0 : _unref2.avatar,
            size: "32"
          }, null, 8, ["avatarUrl"]), _createElementVNode("span", _hoisted_4, _toDisplayString((_unref3 = _unref(stuItem)) === null || _unref3 === void 0 ? void 0 : _unref3.userName), 1)])]), _createElementVNode("div", _hoisted_5, [_createVNode(TargetTree, {
            treeData: _unref(treeData),
            onCheckTarget: _cache[0] || (_cache[0] = function ($event) {
              return _unref(checkTargetEvent)($event, 0);
            })
          }, null, 8, ["treeData"]), _createVNode(Evaluate, {
            ref_key: "evaluateRef",
            ref: evaluateRef,
            data: _unref(targetItem),
            commentData: _unref(commentData)
          }, null, 8, ["data", "commentData"])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_svg_icon, {
            name: "tip-info",
            size: "14"
          }), _createElementVNode("span", null, "指标已被评价" + _toDisplayString(_unref(count)) + "次", 1)]), _createElementVNode("div", null, [_createVNode(_component_t_button, {
            class: "cancel-btn",
            onClick: cancelEvent
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode("取消", -1)]));
            }),
            _: 1
          }), _createVNode(_component_t_button, {
            class: "submit-btn",
            disabled: _unref(submitLoading),
            loading: _unref(submitLoading),
            onClick: submitEvent
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode(" 提交 ", -1)]));
            }),
            _: 1
          }, 8, ["disabled", "loading"])])])])];
        }),
        _: 1
      }, 8, ["visible", "onClosed"]);
    };
  }
};